import { ApiPathConfig } from '../types';
import { AdminUsersQueryDTO, AdminUsersResponseDTO } from 'infrastructure/dtos/admin';

function buildAdminUsersQueryString(dto: AdminUsersQueryDTO): string {
  const params = new URLSearchParams();
  if (dto.search != null && dto.search !== '') params.set('search', dto.search);
  if (dto.role != null) params.set('role', dto.role);
  if (dto.per_page != null) params.set('per_page', String(dto.per_page));
  if (dto.page != null) params.set('page', String(dto.page));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const GetUsers: ApiPathConfig<AdminUsersQueryDTO, AdminUsersResponseDTO> = {
  method: 'GET',
  path: '/admin/users',
  response: {} as AdminUsersResponseDTO,
  buildRoute: (dto: AdminUsersQueryDTO): string => {
    return `/admin/users${buildAdminUsersQueryString(dto)}`;
  },
};
